import { Box, Typography } from '@mui/material';
import React from 'react';
import moment from '../../utils/moment';
import { DATE_FORMAT } from '../../utils/constants';

const DateDivider = ({ current, previous }) => {
  if (
    !previous ||
    moment(current.date).format(DATE_FORMAT) !==
      moment(previous.date).format(DATE_FORMAT)
  ) {
    return (
      <Box with="100%" textAlign={'center'} paddingTop={2}>
        <Typography>{moment(current.date).format(DATE_FORMAT)}</Typography>
      </Box>
    );
  }
  return null;
};

export default DateDivider;
